import React from "react"
import tw from "twin.macro"

import { withCustomerOrders } from "./withCustomerOrders"
import { CustomerOrdersCard } from "./Card/CustomerOrdersCard"
import { RichText } from "../../RichText/RichText"

const Title = tw.div`uppercase text-14 pb-1-6 md:pb-4` // styledsmall
const Description = tw.div`pb-1-6 md:pb-4 text-left`

export const CustomerOrders = withCustomerOrders(
  ({ title, content }): JSX.Element => (
    <>
      <Title className="body_small_highlight">{title}</Title>
      {content ? (
        <Description>
          <RichText sanity>{content}</RichText>
        </Description>
      ) : null}
      <CustomerOrdersCard />
    </>
  )
)
